import { ProcessRouteStepInput } from "gql/graphql";

/** Значение шага из формы → вход схемы: ровно одно поле, без id и без явных null. */
export function toProcessRouteStepInput(step: {
  role?: string | null;
  person?: string | null;
}): ProcessRouteStepInput {
  if (step.role) {
    return { role: step.role };
  }

  if (step.person) {
    return { person: step.person };
  }

  return {};
}
